import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import FeedbackCard from '../../../components/feedback/FeedbackCard';
import SortingComponent from '../../../components/feedback/SortingComponent';

class FeedbackList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorting: 0,
    };
  }

  render() {
    const { feedbackList } = this.props;

    return (
      <React.Fragment>
        <Grid container spacing={16}>
          {feedbackList.map(feedback => (
            <Grid item key={feedback.id} xs={12} md={6} xl={4}>
              <FeedbackCard feedback={feedback} />
            </Grid>
          ))}
        </Grid>

        <SortingComponent visible={this.state.sortingModalVisible} />
      </React.Fragment>
    );
  }
}

export default FeedbackList;



// WEBPACK FOOTER //
// ./src/routes/home/feedbackList/FeedbackList.js